<div class="login-container">
    <div class="login-card">
        <!-- Logo + Brand -->
        <div class="logo-section">
            <img src="assets/images/logo2.png" alt="beExpert Logo" class="logo" />
            <h2 class="brand">BeExpert</h2>
        </div>

        <!-- Title -->
        <h1 class="title">Admin Panel</h1>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
            <!-- Email -->
            <div class="form-group">
                <label for="email">Email Address</label>
                <div class="input-wrapper">
                    <i class="bi bi-envelope"></i>
                    <input type="email" id="email" formControlName="email" placeholder="Enter your email"
                        autocomplete="off" autocorrect="off" />
                </div>
                <small class="error" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid">
                    Please enter a valid email address
                </small>
            </div>

            <!-- Password -->
            <div class="form-group">
                <label for="password">Password</label>
                <div class="input-wrapper">
                    <i class="bi bi-lock"></i> <input [type]="showPassword ? 'text' : 'password'" id="password"
                        formControlName="password" placeholder="Enter your password" autocomplete="off"
                        autocorrect="off" />
                    <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'" (click)="togglePassword()"></i>
                </div>
                <small class="error" *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
                    Password is required (min 6 characters)
                </small>
            </div>

            <!-- Button -->
            <button type="submit" class="btn-login" [disabled]="loginForm.invalid">
                Sign In <i class="bi bi-box-arrow-right"></i>
            </button>
        </form>
    </div>
</div>